import React from "react";

const TemarioPosgradoEnfermeriaOncologica = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <span className="temario-module-heading">{"Materia 1: Fundamentos Clínicos de la EPA en Oncología"}</span>
            <br /><br />
            <b>{"Biología y Carcinogénesis"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Apertura del programa. Ciclo celular normal, biología de la célula cancerosa y mecanismos moleculares de la carcinogénesis."}</span></li>
            </ul>
            <br /><br />
            <b>{"Epidemiología y Cribado en Argentina"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Epidemiología del cáncer en Argentina: incidencia y prevalencia. Programas nacionales de cribado y rol de la enfermería en el diseño de políticas públicas preventivas."}</span></li>
            </ul>
            <br /><br />
            <b>{"Particularidades del Paciente Pediátrico"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Patologías oncológicas infantiles de mayor incidencia en el país y perfiles de respuesta biológica."}</span></li>
            </ul>
            <br /><br />
            <b>{"Métodos de Diagnóstico Avanzado"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Estudios por imágenes, marcadores tumorales, biopsia líquida, estadificación clínica y clasificación TNM."}</span></li>
            </ul>
            <br /><br />
            <b>{"Diagnóstico y Debut Pediátrico"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Métodos diagnósticos, estadios y clasificación de tumores en la infancia. Intervención de la EPA ante el impacto del debut oncológico pediátrico."}</span></li>
            </ul>

            <span className="temario-module-heading">{"Materia 2: Modelos de Continuidad Asistencial y Consulta Autónoma"}</span>
            <br /><br />
            <b>{"Consulta Autónoma de Enfermería"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Estructura, valoración avanzada de síntomas y seguimiento clínico continuo."}</span></li>
            </ul>
            <br /><br />
            <b>{"Redes de Cuidado y Nurse Navigator"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"El rol de la Nurse Navigator (Enfermera Navegadora) y la eliminación de barreras en el sistema de salud."}</span></li>
            </ul>
            <br /><br />
            <b>{"Atención Centrada en la Persona"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Integración familiar en la continuidad del cuidado en adultos y pediatría."}</span></li>
            </ul>

            <span className="temario-module-heading">{"Materia 3: Introducción a los Cuidados Paliativos Tempranos"}</span>
            <br /><br />
            <b>{"Cuidados Paliativos en Adultos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Control avanzado del dolor y síntomas refractarios desde las etapas iniciales del tratamiento activo."}</span></li>
            </ul>
            <br /><br />
            <b>{"Cuidados Paliativos Pediátricos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Abordaje integral de los aspectos físicos, emocionales y espirituales del niño y su familia."}</span></li>
            </ul>

            <span className="temario-module-heading">{"Materia 4: Pilares del Tratamiento Oncológico y Soporte Técnico"}</span>
            <br /><br />
            <b>{"Tratamientos Locales Avanzados"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Cirugía oncológica, radioterapia y cobalto. Cuidados específicos de enfermería e intervenciones de soporte."}</span></li>
            </ul>
            <br /><br />
            <b>{"Tratamiento Sistémico Clásico"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Quimioterapia antineoplásica, clasificaciones farmacológicas y mecanismos de acción celular."}</span></li>
            </ul>
            <br /><br />
            <b>{"Farmacología Oncológica de Vanguardia"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Bioterapia, inmunoterapia, terapias target y anticuerpos monoclonales. Manejo de efectos inmunomediados."}</span></li>
            </ul>
            <br /><br />
            <b>{"Oncohematología del Adulto y TMO"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Leucemias, linfomas, mielomas y pilares del Trasplante de Médula Ósea (TMO)."}</span></li>
            </ul>
            <br /><br />
            <b>{"Oncohematología Pediátrica"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Manejo clínico de la leucemia infantil y protocolos de soporte hematológico intensivo en pediatría."}</span></li>
            </ul>

            <span className="temario-module-heading">{"Materia 5: Gestión Clínica de Toxicidades y Accesos Vasculares"}</span>
            <br /><br />
            <b>{"Algoritmos de Decisión ante Toxicidades"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Manejo autónomo de náuseas, vómitos, neutropenia febril, mucositis y toxicidad dérmica."}</span></li>
            </ul>
            <br /><br />
            <b>{"Terapia de Infusión y Accesos Vasculares"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Selección, colocación y rescate de catéteres implantables (Port-a-Cath), semiimplantables (Hickman) y PICC."}</span></li>
            </ul>
            <br /><br />
            <b>{"Protocolos de Administración Segura"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Circuito cerrado de infusión, sistemas de doble control y prevención de errores de medicación en la cabecera."}</span></li>
            </ul>
            <br /><br />
            <b>{"Adherencia Terapéutica y Educación"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Estrategias en consultorio para el manejo domiciliario de tratamientos orales y soporte nutricional integral."}</span></li>
            </ul>
            <br /><br />
            <b>{"Taller de Integración Clínica Avanzada"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Integración clínica y análisis de casos complejos de toxicidad y tratamiento."}</span></li>
            </ul>

            <span className="temario-module-heading">{"Materia 6: Ingeniería de Procesos y Bioseguridad en Servicios Oncológicos"}</span>
            <br /><br />
            <b>{"Organización del Hospital de Día"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Organización del Hospital de Día Oncológico para adultos y pacientes pediátricos: modelos de gestión, optimización de sillones y asignación predictiva de turnos."}</span></li>
            </ul>
            <br /><br />
            <b>{"Bioseguridad e Infraestructura Macro"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Centrales de mezclas oncológicas, cabinas de flujo laminar y normativas de residuos citostáticos."}</span></li>
            </ul>

            <span className="temario-module-heading">{"Materia 7: Dirección de Recursos Humanos y Gestión del Riesgo"}</span>
            <br /><br />
            <b>{"Modelos de Gestión y Dotación Segura"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Metodologías de cálculo de dotación segura en oncología según niveles de dependencia y horas de cuidado."}</span></li>
            </ul>
            <br /><br />
            <b>{"Gestión del Talento de Elite"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Selección por competencias, perfiles de puestos para áreas oncológicas y diseño de matrices de inducción técnica."}</span></li>
            </ul>
            <br /><br />
            <b>{"Seguridad del Paciente y Eventos Centinela"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Gestión del riesgo asistencial y protocolización ante eventos centinela, extravasaciones y derrames de citostáticos."}</span></li>
            </ul>
            <br /><br />
            <b>{"Aspectos Jurídicos y Ley Nicolás"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Aspectos jurídicos y legales de la práctica oncológica. Implementación práctica de la Ley Nicolás en unidades de alta complejidad y blindaje legal corporativo."}</span></li>
            </ul>

            <span className="temario-module-heading">{"Materia 8: Calidad Asistencial"}</span>
            <br /><br />
            <b>{"Auditoría y Acreditación"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Gestión de calidad y tablero de comando."}</span></li>
            </ul>
            <br /><br />
            <b>{"Auditoría y Acreditación"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Auditoría clínica de enfermería."}</span></li>
            </ul>
            <br /><br />
            <b>{"Auditoría y Acreditación"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Procesos de acreditación institucional."}</span></li>
            </ul>
            <br /><br />
            <b>{"Auditoría y Acreditación"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Taller de integración de gestión."}</span></li>
            </ul>

            <span className="temario-module-heading">{"Materia 9: Finanzas"}</span>
            <br /><br />
            <b>{"Economía de la Salud y Transformación Digital"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Introducción a la economía de la salud."}</span></li>
            </ul>
            <br /><br />
            <b>{"Economía de la Salud y Transformación Digital"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Gestión financiera y medicamentos MEAP."}</span></li>
            </ul>
            <br /><br />
            <b>{"Economía de la Salud y Transformación Digital"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Evaluación de Tecnologías Sanitarias (ETS)."}</span></li>
            </ul>
            <br /><br />
            <b>{"Economía de la Salud y Transformación Digital"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Inteligencia artificial y transformación digital en oncología."}</span></li>
            </ul>

            <span className="temario-module-heading">{"Materia 10: Enfermería Basada en la Evidencia e Investigación Operativa"}</span>
            <br /><br />
            <b>{"Metodología EBE Aplicada a la Gestión"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Formulación de preguntas PICO y búsqueda avanzada en bases de datos indexadas de elite: PubMed, Cochrane y CINAHL."}</span></li>
            </ul>
            <br /><br />
            <b>{"Lectura Crítica de Ensayos Clínicos"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Interpretación estadística y traslación de guías internacionales (ASCO, ONS y EONS) a protocolos locales."}</span></li>
            </ul>

            <span className="temario-module-heading">{"Materia 11: Alta Dirección"}</span>
            <br /><br />
            <b>{"Bioética y Gestión del Bienestar"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Liderazgo transformador y bioética."}</span></li>
            </ul>
            <br /><br />
            <b>{"Bioética y Gestión del Bienestar"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Neurobiología del estrés y burnout."}</span></li>
            </ul>
            <br /><br />
            <b>{"Bioética y Gestión del Bienestar"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Departamento de bienestar y cronobiología."}</span></li>
            </ul>
            <br /><br />
            <b>{"Bioética y Gestión del Bienestar"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Cierre del programa y evaluación final."}</span></li>
            </ul>
        </div>
    );
};

export default TemarioPosgradoEnfermeriaOncologica;
